// Trial Balance Mutations

export const setTrialBalanceList = (state, payload) => {
  state.trialBalanceList = payload
}
